<template lang="html">
  <li class="item-content item-input">
    <div v-if="media" class="item-media"><slot name="media" /></div>
    <div class="item-inner">
      <div v-if="label"
        class="item-title item-label"
        :class="{ 'item-floating-label': floating }">
        {{ label }}
      </div>
      <div class="item-input-wrap">
        <slot />
        <span v-if="clearable" class="input-clear-button" />
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: 'ItemInput',
  props: {
    label: {
      type: String
    },
    media: {
      type: Boolean
    },
    clearable: {
      type: Boolean
    },
    floating: {
      type: Boolean
    }
  }
}
</script>
